/* VAYRON — Skin Clinic interactions */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function split(el) {
    if (el.dataset.scSplitDone) return;
    el.dataset.scSplitDone = '1';
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const w = document.createElement('span');
            w.className = 'sc-split-word';
            const inner = document.createElement('span');
            inner.style.setProperty('--i', i++);
            inner.textContent = part;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') {
          walk(n);
        }
      });
    };
    walk(el);
  }

  function init(root = document) {
    root.querySelectorAll('.sc-split').forEach(split);

    const targets = root.querySelectorAll('[data-sc-reveal], .sc-split, .sc-routine');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach((t) => t.classList.add('is-in'));
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      targets.forEach((t) => io.observe(t));
    }

    root.querySelectorAll('[data-sc-count]').forEach((el) => {
      const end = parseFloat(el.dataset.scCount);
      if (isNaN(end) || end === 0 || reduce || !('IntersectionObserver' in window)) return;
      const run = () => {
        const t0 = performance.now();
        const step = (t) => {
          const p = Math.min(1, (t - t0) / 1400);
          el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.6 });
      el.textContent = '0';
      io.observe(el);
    });

    root.querySelectorAll('[data-sc-tabs]').forEach((wrap) => {
      const tabs = wrap.querySelectorAll('.sc-ingr__tab');
      const panels = wrap.querySelectorAll('[data-panel]');
      const orb = wrap.querySelector('.sc-orb');
      const activate = (idx) => {
        tabs.forEach((t, i) => { t.classList.toggle('is-active', i === idx); t.setAttribute('aria-selected', i === idx); });
        panels.forEach((p, i) => p.classList.toggle('is-active', i === idx));
        const t = tabs[idx];
        if (orb && t) { orb.style.setProperty('--o1', t.dataset.c1); orb.style.setProperty('--o2', t.dataset.c2); }
      };
      tabs.forEach((t, i) => t.addEventListener('click', () => { activate(i); wrap.dataset.userPicked = '1'; }));
      activate(0);
      if (!reduce && tabs.length > 1) {
        let idx = 0;
        const timer = setInterval(() => {
          if (wrap.dataset.userPicked) { clearInterval(timer); return; }
          idx = (idx + 1) % tabs.length; activate(idx);
        }, 4200);
      }
    });

    root.querySelectorAll('.sc-faq details').forEach((d) => {
      const summary = d.querySelector('summary');
      const body = d.querySelector('.sc-faq__body');
      if (!summary || !body || reduce || !body.animate) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.open) {
          const h = body.scrollHeight;
          body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 380, easing: 'cubic-bezier(.22,.8,.22,1)' }).onfinish = () => (d.open = false);
        } else {
          d.open = true;
          const h = body.scrollHeight;
          body.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 420, easing: 'cubic-bezier(.22,.8,.22,1)' });
        }
      });
    });

    root.querySelectorAll('.sc-qty').forEach((q) => {
      const input = q.querySelector('input');
      q.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1));
      }));
    });
  }

  function parallax() {
    if (reduce) return;
    const items = document.querySelectorAll('[data-sc-parallax]');
    if (!items.length) return;
    let ticking = false;
    const update = () => {
      const y = window.scrollY;
      items.forEach((el) => { el.style.transform = `translate3d(0, ${y * (parseFloat(el.dataset.scParallax) || 0.1)}px, 0)`; });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
  }

  function headerState() {
    const on = () => document.body.classList.toggle('sc-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  const start = () => { init(); parallax(); headerState(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();